import { PromptTemplate } from '../types';

const IMAGE_STYLES = [
  'photo', 'art', 'anime', '3d', 'digital-art', 'oil-painting',
  'watercolor', 'sketch', 'cartoon', 'realistic', 'abstract', 
  'minimalist', 'vintage', 'modern'
];

// Valid Runware API dimensions: multiples of 64, between 128-1024 for optimal performance
const IMAGE_SIZES = [
  '256x256', '512x512', '768x768', '1024x1024', // Square formats
  '512x768', '768x512', // Portrait/Landscape 4:3 ratio
  '1024x768', '768x1024' // Portrait/Landscape 4:3 ratio
];

export const imagePrompt: PromptTemplate = {
  type: 'image',
  template: `First, provide a helpful conversational response that:
1. Acknowledges the user's visual content need naturally
2. Explains why creating this image would enhance their project or communication
3. Provides context about visual design principles, style considerations, or creative approaches

Then, if you believe the user wants an image generation recommendation, include this structured format below your conversational response:

---RECOMMENDATION---
IMAGE DESCRIPTION: [detailed description of the image to generate, including composition, mood, and key elements]
IMAGE STYLE: [Select ONE of these styles: ${IMAGE_STYLES.join(', ')}]
IMAGE SIZE: [Select ONE of these sizes: ${IMAGE_SIZES.join(', ')}. IMPORTANT: Dimensions must be multiples of 64 and max 1024px for height/width]
---END RECOMMENDATION---

Provide both the conversational response AND the structured recommendation in a single response. The conversational part maintains natural dialogue flow while the structured part enables action card creation.

OR if you need extra context to provide the perfect recommendation, continue chatting conversationally without the structured format.`,
  validation: {
    requiredFields: ['IMAGE DESCRIPTION', 'IMAGE STYLE', 'IMAGE SIZE'],
    stopKeywords: ['---RECOMMENDATION---', '---END RECOMMENDATION---'],
    maxRecommendations: 1,
    allowedValues: {
      'IMAGE STYLE': IMAGE_STYLES,
      'IMAGE SIZE': IMAGE_SIZES
    }
  }
}; 